import React, { useState, useEffect, useRef, useMemo, useLayoutEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import SwiperItem from './GetStarted/Items/SwiperItem';
import GetStartedModals from './GetStarted/Modals/GetStartedModals';
import translations from '../../text/get-started-translations.json';
import { fetchGetStarted, fetchGetStartedBox } from '../functions/fetchGetStarted';
import { resetHeight } from '../functions/ResetHeight';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import FeaturePlan from './GetStarted/FeaturePlan';
import FilterModal from './GetStarted/Modals/FilterModal/FilterModal';
import STBIntroduction from './GetStarted/components/STBIntroduction/STBIntroduction';
import { PackInfo, Plan, IChannels, ILibraries } from './types';
import { useAppDispatch, useAppSelector } from '../../stores/hook';
import { setNowEStatus, setFilterPlansInfo, setHideOtherPacks, setisShowFitlerPopUp, setIsTvBoxPage, setPackInfo, setSubscribeModalStatus } from './GetStarted/GetStartedSlice';
import { useLocation } from 'react-router-dom';
import cx from 'classnames';
import language from '../../utils/LanguageSettings';
import { Link } from 'react-router-dom';
import { appendUtmParams } from '../../utils/Url';
import { adult, dayPass, entertainment, foreignLanguage, funNLearn, infotainment, movie, sports } from './constants';
import GenreList from './GetStarted/components/GenreList/GenreList';
import RenderSnA from '../functions/renderSnA';
import { scrollToCampaign } from '../functions/scrollToCampaign';
import { useSearchParams } from 'react-router-dom';
import { SOURCE_URL } from '../../config';
import ImageFallback from '../../utils/ImageFallback';
import { getPlansSwiperConfig } from '../functions/getPlansSwiperConfig';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import helpCircleOutline from '../../images/icon/help-circle-outline.svg';
import nowELogo from '../../images/icon/nowe_logo.svg';
import tvBoxZh from "../../images/get-started/tv-box-zh-3.png";
import tvBoxEn from "../../images/get-started/tv-box-en-3.png";
import notFoundWbgE from '../../images/icon/notfound-wbg-e.png';
import notFoundWbgC from '../../images/icon/notfound-wbg-c.png';
import { filterCustomerTypeDisplay } from '../functions/filterCustomerTypeDisplay';

interface GetStartedProps {
  // className?: string;
  // combopacks: any[];
}

const GetStarted: React.FC<GetStartedProps> = () => {
  const GET_STARTED_BOX = '/get-started-box';
  const pageTranslations = translations[language]; // Select the correct translations
  const [heading, setHeading] = useState<string | null>(null);
  const [bottom, setBottom] = useState<string | null>(null);
  const [featurePlans, setFeaturePlans] = useState<Plan[]>([]);
  const [allPlans, setAllPlans] = useState<Plan[]>([]);
  const [genrePlans, setgenrePlans] = useState<Plan[]>([]);
  const [channels, setChannel] = useState<any[]>([]);
  const [libraries, setLibrary] = useState<any[]>([]);
  const [seo, setSeo] = useState<any>(null);
  const [ga, setGa] = useState<any>(null);
  const location = useLocation();
  const [comboPacks, setComboPacks] = useState<any[]>([]);
  const [hash, setHash] = useState(window.location.hash);
  // const [fitlerBtnTxt, setFilterBtnTxt] = useState<string>(pageTranslations.PlansBtn);

  const filterSwiperRef = useRef<any>(null);
  const filterChannelOrLibInfo = useAppSelector((state) => state.getStarted.filterChannelOrLibInfo);
  const hideOtherPacks = useAppSelector((state) => state.getStarted.hideOtherPacks);
  const isShowFitlerPopUp = useAppSelector((state) => state.getStarted.isShowFitlerPopUp);
  const isTvBoxPage = useAppSelector((state) => state.getStarted.isTvBoxPage);
  const link = window.myAppStrapi && window.myAppStrapi.phpButtonLink ? window.myAppStrapi.phpButtonLink : '';
  const campaignCodes = window.myAppStrapi && window.myAppStrapi.campaignCodeArray ? window.myAppStrapi.campaignCodeArray : {};

  const campaignCodeMap = new Map(Object.entries(campaignCodes));

  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const nowe = searchParams.get('nowe');
  const [noweMessgae1, setNoweMessgae1] = useState<string | "">("");
  const [noweMessgae2, setNoweMessgae2] = useState<string | "">("");
  const [showNowE,setShowNowE] = useState<boolean | false>(false);

  const libid = searchParams.get('libid');
  const channelid = searchParams.get('channelid');
  const campaignParam = searchParams.get('campaign');

  const defaultSrc = language === "zh"? `${notFoundWbgC}` : `${notFoundWbgE}`;

  useEffect(() => {
    const handleHashChange = () => {
      setHash(window.location.hash);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);
  

  const filterbtnTxt = useMemo(() => {
    if (hideOtherPacks) {
      return pageTranslations.PlansFilterBtn;
    } else {
      return pageTranslations.PlansBtn;
    }
  }, [hideOtherPacks, pageTranslations.PlansBtn, pageTranslations.PlansFilterBtn]);

  const filterPlans = useMemo(() => {
    const filterData: any = [];
    if (allPlans.length > 0) {
      const packsData = comboPacks.map((pack: any) => pack.attributes);
      console.log("Filter: " + filterChannelOrLibInfo?.filterChannelOrLibId);

      if (filterChannelOrLibInfo?.type === 'library') {
        // filter library
        for (const pack of packsData) {
          const libNumbArray = pack?.onDemandNumber?.data;
          if (libNumbArray) {
            const libNumbsOfPack = libNumbArray.map((item: any) => item.attributes.number);
            // if the pack has the library, add all plans of the pack
            if (libNumbsOfPack.includes(filterChannelOrLibInfo?.filterChannelOrLibId)) {
              const planIdsInPack = pack?.plans?.data?.map((plan: { id: any }) => plan.id);
              for (const plan of allPlans) {
                if (planIdsInPack && planIdsInPack.includes(plan.id)) {
                  filterData.push(plan.attributes)
                }
              }
            }
          }
        }
      } else if (filterChannelOrLibInfo?.filterChannelOrLibId) {
        // filter channel
        for (const pack of packsData) {
          const channelNumbArray = pack?.channelsNumber?.data;
          if (channelNumbArray) {
            const channelNumbsOfPack = channelNumbArray.map((item: any) => item.attributes.number);
            // if the pack has the channel, add all plans of the pack
            if (channelNumbsOfPack.includes(filterChannelOrLibInfo?.filterChannelOrLibId)) {
              const planIdsInPack = pack?.plans?.data?.map((plan: { id: any }) => plan.id);
              for (const plan of allPlans) {
                if (planIdsInPack && planIdsInPack.includes(plan.id)) {
                  filterData.push(plan.attributes)
                }
              }
            }
          }
        }
      }
    }
    return [...new Set(filterData.map((item: any) => JSON.stringify(item)))].map((item: any) => JSON.parse(item));
  }, [allPlans, filterChannelOrLibInfo]);

  useLayoutEffect(() => {
    const { pathname } = location;
    if (pathname.replace(/\/+$/, '') === GET_STARTED_BOX) {
      dispatch(setIsTvBoxPage(true));
    } else {
      dispatch(setIsTvBoxPage(false));
    }
  }, [dispatch, location]);

  useEffect(() => {
    if (isShowFitlerPopUp) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isShowFitlerPopUp]);

  const handleFilterClick = (channels: any[], libraries: any[]) => {
    setChannel(channels);
    setLibrary(libraries);
    dispatch(setisShowFitlerPopUp(true));
  };

  const clickNowE = () => {
    dispatch(setNowEStatus(true));
  }

  const filterPopUpClose = () => {
    dispatch(setisShowFitlerPopUp(false));
  };

  const showOtherPacks = () => {
    dispatch(setHideOtherPacks(false));
  };

  const onButtonClick = (e: React.MouseEvent<HTMLButtonElement>, packInfo: PackInfo) => {
    if (packInfo.PriceOptions.length > 1) {
      dispatch(setSubscribeModalStatus(true));
      dispatch(setPackInfo(packInfo));
    } else if (packInfo.PriceOptions && packInfo.PriceOptions.length === 1) {
      if (isTvBoxPage) {
        if (packInfo.PriceOptions[0].Campaign) {
          if (campaignCodeMap.size > 0) {
            const cpm = campaignCodeMap.get(packInfo.PriceOptions[0].Campaign);
            const d = new Date();
            d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
            const expires = 'expires=' + d.toUTCString();
            document.cookie = 'cpm=' + cpm + ';' + expires + ';path=/';
            window.location.href = link;
          }
        }
      } else {
        if (packInfo.PriceOptions[0].Campaign) {
          const url = 'https://ssp.nowtv.now.com/choose-plan?campaign=' + packInfo.PriceOptions[0].Campaign + '&lang=' + language;
          window.location.href = appendUtmParams(url);
        }
      }
    }
  };

  useEffect(() => {
    resetHeight();
  });

  useEffect(() => {
    const { pathname } = location;
    const fetchData = async () => {
      let data;
      if (pathname.replace(/\/+$/, '') === GET_STARTED_BOX) {
        data = await fetchGetStartedBox(language);
      } else {
        data = await fetchGetStarted(language);
      }
      if (data) {
        setHeading(data.getStarted?.attributes.heading || null);
        setBottom(data.getStarted?.attributes.bottom || null);
        setSeo(data.SEO || null);
        setGa(data.GA || null);
        const allFeaturePlans = data ? (data.getStarted?.attributes.plans?.data ? data.getStarted?.attributes.plans?.data : []) : [];
        let filteredFeaturePlans: Plan[] = [];
        if (allFeaturePlans.length > 0) {
          // filter plans that has priceOptions which has at least one price valid
          filteredFeaturePlans = getFilteredPlans(pathname.replace(/\/+$/, '') === GET_STARTED_BOX, allFeaturePlans);
        }
        const allPlans = data.plans ? data.plans : [];
        let filterAllPlans: Plan[] = [];
        if (allPlans.length > 0) {
          // filter plans that has priceOptions which has at least one price valid
          filterAllPlans = getFilteredPlans(pathname.replace(/\/+$/, '') === GET_STARTED_BOX, allPlans);
        }
        let channels: IChannels[] = [];
        let libraries: ILibraries[] = [];
        if (data.getStarted?.attributes.Filter && data.getStarted.attributes.Filter.channels.data) {
          channels = data.getStarted.attributes.Filter.channels.data;
        }
        if (data.getStarted?.attributes.Filter && data.getStarted.attributes.Filter.libraries.data) {
          libraries = data.getStarted.attributes.Filter.libraries.data;
        }
        let planIdsHotpick = filteredFeaturePlans?.map((plan: { id: any }) => plan.id);
        let genreData: Plan[] = [];
        if(!planIdsHotpick) {
          genreData = filterAllPlans;
        } else {
            for (const plan of filterAllPlans) {
                if (!planIdsHotpick.includes(plan.id)) {
                   genreData.push(plan);
                 }
             }
        }
        setFeaturePlans(filterCustomerTypeDisplay(filteredFeaturePlans));
        setAllPlans(filterCustomerTypeDisplay(filterAllPlans) || []);
        setgenrePlans(genreData || []);
        setChannel(channels || []);
        setLibrary(libraries || []);
        setComboPacks(data.combopacks || []);
        if(nowe === "Y"){
          setShowNowE(true);
          setNoweMessgae1(translations[language].nowe1);
          setNoweMessgae2(translations[language].nowe2);
          dispatch(setNowEStatus(true));
        }
      }
    };
    fetchData();
  }, [language]);

  useEffect(()=>{
    if(libid){
      libraries?.forEach(library => {
        if (library.attributes.number === libid) {
          const url = library.attributes?.icon?.data?.attributes?.formats?.thumbnail?.url ? SOURCE_URL + library.attributes.icon.data.attributes.formats.thumbnail.url : library.attributes?.icon?.data?.attributes?.url ? SOURCE_URL + library.attributes.icon.data.attributes.url : defaultSrc;
          dispatch(setHideOtherPacks(true));
          dispatch(setFilterPlansInfo({filterChannelOrLibId: library.attributes.number, filterChanenlOrLibImg: url, type: "library"}));
        }
      });
    } else if(channelid){
        channels?.forEach(channel => {
          if (channel.attributes.number === channelid) {
            const url = channel.attributes?.icon?.data?.attributes?.formats?.thumbnail?.url ? SOURCE_URL + channel.attributes.icon.data.attributes.formats.thumbnail.url : channel.attributes?.icon?.data?.attributes?.url ? SOURCE_URL + channel.attributes.icon.data.attributes.url : defaultSrc;
            dispatch(setHideOtherPacks(true));
            dispatch(setFilterPlansInfo({filterChannelOrLibId: channel.attributes.number, filterChanenlOrLibImg: url, type: "channel"}));
          }
        });
    }
  },[libid,channelid,channels,libraries, dispatch]);

  const filterSwiperConfig = useMemo(() => getPlansSwiperConfig(filterPlans.length, filterSwiperRef), [filterPlans]);

  useEffect(() => {
    resetHeight();
    if (filterSwiperRef.current) {
      filterSwiperRef.current.update();
    }
  }, [filterPlans, allPlans]);



  const getFilteredPlans = (isTvBoxPage: boolean, plans: Plan[]) => {
    let filterPlans: Plan[] = [];
    // only show plans that have priceOption which at least one price is valid
    plans.forEach(plan => {
      if (isTvBoxPage) {
        if (plan.attributes.PriceOptionsSTB && plan.attributes.PriceOptionsSTB.length > 0) {
          const filterPriceOptions = plan.attributes.PriceOptionsSTB.filter(priceOption => {
            return typeof priceOption.Price === 'number' && priceOption.Price >= 0
          });
          if (filterPriceOptions.length > 0) {
            plan.attributes.PriceOptions = filterPriceOptions;
            filterPlans.push(plan);
          }
        }
      } else {
        if (plan.attributes.PriceOptions && plan.attributes.PriceOptions.length > 0) {
          const filterPriceOptions = plan.attributes.PriceOptions.filter(priceOption => {
            return typeof priceOption.Price === 'number' && priceOption.Price >= 0
          });
          if (filterPriceOptions.length > 0) {
            plan.attributes.PriceOptions = filterPriceOptions;
            filterPlans.push(plan);
          }
        }
      }
    });
    return filterPlans;
  }

  const renderFilterPlans = () => {
    return (
      <Swiper key={filterChannelOrLibInfo.filterChannelOrLibId} {...filterSwiperConfig}>
        {filterPlans.map((plan: any, index: number) => (
          <SwiperSlide className="custom-slide" key={`${filterChannelOrLibInfo.filterChannelOrLibId}-${index}`}>
            <SwiperItem
              imgSrc={plan.plan_img?.data?.attributes?.url || ''}
              title={plan.name}
              description={plan.description}
              includes={plan.includes}
              stb_price={plan.stb_price}
              price={plan.price || ''}
              ott_12Mth_price={plan.ott_12Mth_price}
              stb_12Mth_price={plan.stb_12Mth_price}
              ottPriceDetail={plan.ottPriceDetail || ''}
              stbPriceDetail={plan.stbPriceDetail || ''}
              ottCampaign={plan.ott_campaign}
              stbCampaign={plan.stb_campaign}
              stb_12M_campaign={plan.stb_12M_campaign}
              PriceOptions={plan.PriceOptions || []}
              box_detail_id={plan.box_detail_id}
              Tagline={isTvBoxPage ? plan.TaglineSTB : plan.TaglineOTT}
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                const packInfo = {
                  name: plan.name,
                  PriceOptions: plan.PriceOptions || [],
                  optionsContext: plan.optionsContext,
                };
                onButtonClick(e, packInfo);
              }}
            />
          </SwiperSlide>
        ))}
        <div className="swiper-button-next"></div>
        <div className="swiper-button-prev"></div>
      </Swiper>
    );
  };

  const genres = useMemo(() => {
    return [
      { key: dayPass, label: pageTranslations.DayPass },
      { key: sports, label: pageTranslations.Sports },
      { key: movie, label: pageTranslations.Movies },
      { key: entertainment, label: pageTranslations.Entertainment },
      { key: funNLearn, label: pageTranslations.FunnLearn },
      { key: infotainment, label: pageTranslations.Infotainment },
      { key: foreignLanguage, label: pageTranslations.ForeignLanguage },
      { key: adult, label: pageTranslations.Adult },
    ]
  }, [pageTranslations]);

  const renderGenres = useMemo(() => {
    return genres.map((genre, index) => {
      const genrePacks = genrePlans.filter((plan: any) => plan.attributes.genre?.toLowerCase() === genre.key.toLowerCase());
      if (genrePacks.length === 0) {
        return null;
      }
      const campaign = genrePacks.find((plan: any) => plan.attributes.campaignParameter?.toLowerCase().replace(/\s+/g, '-') === campaignParam)
      if(campaignParam && campaign)
        return <GenreList key={genre.key} plans={genrePacks} genre={genre} hash={hash} campaign={campaignParam} />;
      else
        return <GenreList key={genre.key} plans={genrePacks} genre={genre} hash={hash} campaign={''} />;
    });
  }, [genrePlans, genres, hash]);

  useEffect(() => {  
    if (campaignParam) {
      // Add a small delay to ensure DOM is fully rendered
      setTimeout(() => {
        scrollToCampaign(campaignParam);
      }, 2000);
    }
  }, []);

  return (
    <>
      <RenderSnA seo={seo} ga={ga} />
      <section key={location.pathname.replace(/\/+$/, '')} id="main-content" className={cx({ ['set-top-box-page']: isTvBoxPage })}>
        <div className="container-fluid" style={{paddingLeft: '0px', paddingRight: '0px'}}>
          {isTvBoxPage && <STBIntroduction />}

          <div className="get-started-wrapper">
            <div className="container">
              <div className="heading">
                {heading ? (
                  <div>
                    <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{heading}</ReactMarkdown>
                  </div>
                ) : (
                  <h2></h2>
                )}
                {showNowE ? (
                  <div className='likenowE active' onClick={clickNowE}>
                    {noweMessgae1}
                  <img src={nowELogo}/>
                    {noweMessgae2}
                  <img src={helpCircleOutline}/>
                    </div>
                  ) : (
                    <div></div>
                  )
                }
              </div>
            </div>
            <div className="filter-cta">
                <div className={cx('button-wrap', { ['active']: hideOtherPacks })}>
                  <button className="filterBtn" id="filter-plan-btn" onClick={() => handleFilterClick(channels, libraries)}>
                    {filterbtnTxt}
                    {hideOtherPacks &&
                    <ImageFallback
                      key={filterChannelOrLibInfo.filterChannelOrLibId}
                      primarySrc={filterChannelOrLibInfo.filterChanenlOrLibImg}
                      alt="Filter Icon"
                    />}
                  </button>
                  <button style={{ display: !hideOtherPacks ? 'none' : '' }} className="closeFilter" title="close" onClick={showOtherPacks}></button>
                </div>
              </div>
          </div>
          <div className="get-started-wrapper">
            <div className="container">
              {hideOtherPacks && (
                <div className="filter-wrapper">
                  <div className="pack-row">{renderFilterPlans()}</div>
                  <div className="see-all">
                    <Link to="#" onClick={showOtherPacks} className="link arrow closeFilter active">
                      {pageTranslations.SeeAllPlans}
                    </Link>
                  </div>
                </div>
              )}
              <div className="plan-wrapper" style={{ display: hideOtherPacks ? 'none' : '' }}>
                <FeaturePlan plans={featurePlans} />
              </div>

              {!isTvBoxPage && (
                <div className="or-stb-wrapper">
                  <h3>{pageTranslations.Or}</h3>
                  <div className="stb-wrapper">
                    <div className="content">
                      <h2>
                        {pageTranslations.Upgrade}&nbsp;<span className="nowrap">{pageTranslations.Upgrade2}</span>
                      </h2>
                      <p>{pageTranslations.Enjoy4K}</p>

                      <div className="image">
                        <img
                          src={
                            language.indexOf('zh') > -1
                              ? tvBoxZh
                              : tvBoxEn
                          }
                          alt="TV Box"
                        />
                      </div>

                      <div className="chats">
                        <a href="/get-started-box" className="btn primary">
                          {pageTranslations.SeeBoostedBundles}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="heading looking" style={{ display: hideOtherPacks ? 'none' : '' }}>
                <h2>{pageTranslations.SomethingElse}</h2>
                <p>{pageTranslations.SeeMorePacks}</p>
              </div>

              <div className="genre-packs-wrapper" style={{ display: hideOtherPacks ? 'none' : '' }}>
                {renderGenres}
              </div>

              <div className="watch-free-wrapper">
                  {bottom && (
                      <div>
                        <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{bottom}</ReactMarkdown>
                      </div>
                  )}
              </div>
            </div>
         </div>

                    {/* <FilterModal
                        channels={channels}
                        libraries={libraries}
                        /> */}
                    <FilterModal
                        channels={channels}
                        libraries={libraries}
                        onClose={filterPopUpClose}
                        />
                    <GetStartedModals />
                </div>
            </section>
        </>
    );
};

export default GetStarted;